import { fetcher } from '../utils'
import { ComponentRelationshipVO, FromProductRelationshipVO } from '@repo/types'

export default async (input: ComponentRelationshipVO): Promise<FromProductRelationshipVO> =>
  fetcher(`/api/relationship`, 'POST', input)
